module.exports = __webpack_public_path__ + "img/refresh.0b9371a3.svg";